var ChangeEmailButton           = require("./ChangeEmailButton"),
    ChangeIsAdultButton         = require("./ChangeIsAdultButton"),
    ChangePasswordButton        = require("./ChangePasswordButton"),
    ChangePaymentButton         = require("./ChangePaymentButton"),
    ControlGroup                = require("app/ui/ControlGroup"),
    ControlLabel                = require("app/ui/ControlLabel"),
    PageBackgroundSupport       = require("app/ui/PageBackgroundSupport"),
    PaymentsPopupButton         = require("./PaymentsPopupButton"),
    RemoveAccountButton         = require("./RemoveAccountButton"),
    ResubscribeButton           = require("./ResubscribeButton"),
    Scroller                    = require("enyo-ui/Scroller"),
    ScrollerDecoratorScrollbars = require("app/ui/ScrollerDecoratorScrollbars"),
    ImageOptimizerSupport       = require("app/ui/ImageOptimizerSupport"),
    UnsubscribeButton           = require("./UnsubscribeButton"),
    UnsuspendButton             = require("./UnsuspendButton"),
    UpgradeButton               = require("./UpgradeButton"),
    config                      = require("app/config"),
    frameThrottle               = require("enyo-perf/utils").frameThrottle,
    get                         = require("object-path").get,
    isIosApp                    = require("app/utils/isIosApp"),
    kind                        = require("enyo/kind");

require("./PageView.less");
require("app/theme/ScrollerDecoratorScrollbars--page.less");
require("app/theme/ControlGroup--default.less");
require("app/theme/ControlLabel--default.less");

module.exports = kind(/** @lends  app.ProfilePage.PageView.prototype */ {

    /**
     * @private
     */
    name: "app.ProfilePage.PageView",

    /**
     * @private
     */
    mixins: [
        ImageOptimizerSupport,
        PageBackgroundSupport
    ],

    /**
     * @private
     */
    rawBackgroundImageSrc: require("app/theme/assets/page-background-color.png"),

    /**
     * @private
     */
    classes: "app-profile-page-page-view enyo-fit",

    /**
     * The state of this page.
     *
     * @type  {?Object}
     * @public
     */
    state: null,

    /**
     * @private
     */
    components: [{
        name:               "content",
        kind:               ScrollerDecoratorScrollbars,
        classes:            "app-profile-page-page-view__scroller-decorator",
        scrollerPath:       ".owner.$.scroller",
        theme:              "page",
        fadeChromeOnScroll: true,
        components:         [{
            name:           "scroller",
            kind:           Scroller,
            classes:        "app-profile-page-page-view__scroller",
            minWidth:       "100%",
            maxHeight:      "100%",
            vertical:       true,
            horizontal:     false,
            scrollChaining: false,
            components:     [{
                name:    "membershipTitle",
                classes: "app-profile-page-page-view__membership-title",
                tag:     "h3"
            }, {
                classes:    "app-profile-page-page-view__membership-body",
                components: [{
                    name:       "currentSubscription",
                    kind:       ControlGroup,
                    classes:    "app-profile-page-page-view__current-subscription",
                    components: [{
                        name:    "currentSubscriptionLabel",
                        kind:    ControlLabel,
                        classes: "app-profile-page-page-view__current-subscription-label",
                        theme:   "default"
                    }, {
                        name:    "currentSubscriptionValue",
                        classes: "app-profile-page-page-view__current-subscription-value"
                    }, {
                        name:        "upgradeButton",
                        kind:        UpgradeButton,
                        classes:     "app-profile-page-page-view__upgrade-button",
                        canGenerate: !isIosApp
                    }]
                }, {
                    name:       "subscriptionStatus",
                    kind:       ControlGroup,
                    classes:    "app-profile-page-page-view__subscription-status",
                    components: [{
                        name:    "subscriptionStatusLabel",
                        kind:    ControlLabel,
                        classes: "app-profile-page-page-view__subscription-status-label",
                        theme:   "default"
                    }, {
                        name:    "subscriptionStatusValue",
                        classes: "app-profile-page-page-view__subscription-status-value"
                    }, {
                        name:        "unsuspendButton",
                        kind:        UnsuspendButton,
                        classes:     "app-profile-page-page-view__unsuspend-button",
                        canGenerate: !isIosApp
                    }, {
                        name:    "unsubscribeButton",
                        kind:    UnsubscribeButton,
                        classes: "app-profile-page-page-view__unsubscribe-button"
                    }, {
                        name:    "resubscribeButton",
                        kind:    ResubscribeButton,
                        classes: "app-profile-page-page-view__resubscribe-button"
                    }]
                }, {
                    name:       "accountStatus",
                    kind:       ControlGroup,
                    classes:    "app-profile-page-page-view__account-status",
                    components: [{
                        name:    "accountStatusValue",
                        classes: "app-profile-page-page-view__account-status-value"
                    }, {
                        name:    "removeAccountButton",
                        kind:    RemoveAccountButton,
                        classes: "app-profile-page-page-view__remove-account-button"
                    }]
                }, {
                    name:       "renewalDate",
                    kind:       ControlGroup,
                    classes:    "app-profile-page-page-view__renewal-date",
                    components: [{
                        name:    "renewalDateLabel",
                        kind:    ControlLabel,
                        classes: "app-profile-page-page-view__renewal-date-label",
                        theme:   "default"
                    }, {
                        name:    "renewalDateValue",
                        classes: "app-profile-page-page-view__renewal-date-value"
                    }]
                }, {
                    name:       "endDate",
                    kind:       ControlGroup,
                    classes:    "app-profile-page-page-view__end-date",
                    components: [{
                        name:    "endDateLabel",
                        kind:    ControlLabel,
                        classes: "app-profile-page-page-view__end-date-label",
                        theme:   "default"
                    }, {
                        name:    "endDateValue",
                        classes: "app-profile-page-page-view__end-date-value"
                    }]
                }, {
                    name:        "payments",
                    kind:        ControlGroup,
                    classes:     "app-profile-page-page-view__payments",
                    canGenerate: !isIosApp,
                    components:  [{
                        name:    "paymentsLabel",
                        kind:    ControlLabel,
                        classes: "app-profile-page-page-view__payments-popup-label",
                        theme:   "default"
                    }, {
                        classes: "app-profile-page-page-view__payments-popup-spacer"
                    }, {
                        name:    "paymentsPopupButton",
                        kind:    PaymentsPopupButton,
                        classes: "app-profile-page-page-view__payments-popup-button"
                    }]
                }, {
                    name:        "paymentMethod",
                    kind:        ControlGroup,
                    classes:     "app-profile-page-page-view__payment-method",
                    canGenerate: !isIosApp,
                    components:  [{
                        name:    "paymentMethodLabel",
                        kind:    ControlLabel,
                        classes: "app-profile-page-page-view__payment-method-label",
                        theme:   "default"
                    }, {
                        name:    "paymentMethodValue",
                        classes: "app-profile-page-page-view__payment-method-value"
                    }, {
                        name:    "changePaymentButton",
                        kind:    ChangePaymentButton,
                        classes: "app-profile-page-page-view__change-payment-button"
                    }]
                }]
            }, {
                name:    "profileTitle",
                classes: "app-profile-page-page-view__profile-title",
                tag:     "h3"
            }, {
                classes:    "app-profile-page-page-view__profile-body",
                components: [{
                    name:       "email",
                    kind:       ControlGroup,
                    classes:    "app-profile-page-page-view__email",
                    components: [{
                        name:    "emailLabel",
                        kind:    ControlLabel,
                        classes: "app-profile-page-page-view__email-label",
                        theme:   "default"
                    }, {
                        name:    "emailValue",
                        classes: "app-profile-page-page-view__email-value"
                    }]
                }, {
                    name:    "changeEmailButton",
                    kind:    ChangeEmailButton,
                    classes: "app-profile-page-page-view__change-email-button"
                }, {
                    name:       "password",
                    kind:       ControlGroup,
                    classes:    "app-profile-page-page-view__password",
                    components: [{
                        name:    "passwordLabel",
                        kind:    ControlLabel,
                        classes: "app-profile-page-page-view__password-label",
                        theme:   "default"
                    }, {
                        name:    "passwordValue",
                        classes: "app-profile-page-page-view__password-value"
                    }]
                }, {
                    name:    "changePasswordButton",
                    kind:    ChangePasswordButton,
                    classes: "app-profile-page-page-view__change-password-button"
                }, {
                    name:       "isAdult",
                    kind:       ControlGroup,
                    classes:    "app-profile-page-page-view__is-adult",
                    components: [{
                        name:    "isAdultLabel",
                        kind:    ControlLabel,
                        classes: "app-profile-page-page-view__is-adult-label",
                        theme:   "default"
                    }, {
                        name:    "isAdultValue",
                        classes: "app-profile-page-page-view__is-adult-value"
                    }]
                }, {
                    name:    "changeIsAdultButton",
                    kind:    ChangeIsAdultButton,
                    classes: "app-profile-page-page-view__change-is-adult-button"
                }]
            }]
        }]
    }],

    /**
     * @private
     */
    observers: {
        update: ["passwordVisible", "state"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.authService.user", this.update);
            this.observe("app.$.authService.isLoggedIn", this.update);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * @public
     */
    update: function() {
        var authService   = this.app.$.authService,
            i18nService   = this.app.$.i18nService,
            state         = this.state || {},
            renewalDate   = get(authService, "user.next_payment_date", null),
            endDate       = get(authService, "user.subscription_end", null),
            paymentMethod = get(authService, "user.payment_method", null);

        if (authService.isLoggedIn !== 1) {
            this.$.content.hide();
        }
        else {
            this.$.content.show();
        }

        this.$.membershipTitle.set("content", i18nService.getString("app.ProfilePage.MembershipSection.title"));

        if (get(config, "profile.showSubscription", true)) {
            this.$.currentSubscriptionLabel.set("content", i18nService.getString("app.ProfilePage.MembershipSection.currentSubscriptionLabel"));
            this.$.currentSubscriptionValue.set("content", i18nService.getString("app.ProfilePage.MembershipSection.currentSubscriptionValue", {
                subscription: (get(authService, "user.subscription.name", null) || "").replaceAll("-", "_")
            }));
            this.$.currentSubscription.show();
        }
        else {
            this.$.currentSubscription.hide();
            this.$.currentSubscriptionLabel.set("content", "");
            this.$.currentSubscriptionValue.set("content", "");
        }

        this.$.upgradeButton.set("state", state);

        if (get(config, "profile.showSubscriptionStatus", true)) {
            this.$.subscriptionStatusLabel.set("content", i18nService.getString("app.ProfilePage.MembershipSection.subscriptionStatusLabel"));
            this.$.subscriptionStatusValue.set("content", i18nService.getString("app.ProfilePage.MembershipSection.subscriptionStatusValue", {
                status: get(authService, "user.status", null) || ""
            }));
            this.$.subscriptionStatus.show();
        }
        else {
            this.$.subscriptionStatus.hide();
            this.$.subscriptionStatusLabel.set("content", "");
            this.$.subscriptionStatusValue.set("content", "");
        }

        if (get(config, "profile.allowAccountRemoval", true)
            && get(authService, "user.account_removable", false)) {
            this.$.accountStatus.show();
        }
        else {
            this.$.accountStatus.hide();
        }

        if (get(config, "profile.showRenewalDate", true) && renewalDate) {
            this.$.renewalDateLabel.set("content", i18nService.getString("app.ProfilePage.MembershipSection.renewalDateLabel"));
            this.$.renewalDateValue.set("content", i18nService.getString("app.ProfilePage.MembershipSection.renewalDateValue", {
                renewalDate: renewalDate ? new Date(renewalDate) : null
            }));
            this.$.renewalDate.show();
        }
        else {
            this.$.renewalDate.hide();
            this.$.renewalDateLabel.set("content", "");
            this.$.renewalDateValue.set("content", "");
        }

        if (get(config, "profile.showEndDate", true) && endDate) {
            this.$.endDateLabel.set("content", i18nService.getString("app.ProfilePage.MembershipSection.endDateLabel"));
            this.$.endDateValue.set("content", i18nService.getString("app.ProfilePage.MembershipSection.endDateValue", {
                endDate: endDate ? new Date(endDate) : null
            }));
            this.$.endDate.show();
        }
        else {
            this.$.endDate.hide();
            this.$.endDateLabel.set("content", "");
            this.$.endDateValue.set("content", "");
        }

        if (get(config, "profile.showPayments", true) && get(state, "data.payments.length", 0)) {
            this.$.paymentsLabel.set("content", i18nService.getString("app.ProfilePage.MembershipSection.paymentsLabel"));
            this.$.paymentsPopupButton.set("state", state);
            this.$.payments.show();
        }
        else {
            this.$.payments.hide();
            this.$.paymentsLabel.set("content", "");
            this.$.paymentsPopupButton.set("state", null);
        }

        if (get(config, "profile.showPaymentMethod", true)
            && paymentMethod
            && paymentMethod !== "none"
            && paymentMethod !== "unknown"
        ) {
            this.$.paymentMethodLabel.set("content", i18nService.getString("app.ProfilePage.MembershipSection.paymentMethodLabel"));
            this.$.paymentMethodValue.set("content", i18nService.getString("app.ProfilePage.MembershipSection.paymentMethodValue", {
                method: paymentMethod
            }));
            this.$.paymentMethod.show();
        }
        else {
            this.$.paymentMethodLabel.set("content", "");
            this.$.paymentMethodValue.set("content", "");
            this.$.paymentMethod.hide();
        }

        this.$.profileTitle.set("content", i18nService.getString("app.ProfilePage.ProfileSection.title"));

        this.$.emailLabel.set("content", i18nService.getString("app.ProfilePage.ProfileSection.emailLabel"));
        this.$.emailValue.set("content", get(authService, "user.email", null) || "");

        this.$.passwordLabel.set("content", i18nService.getString("app.ProfilePage.ProfileSection.passwordLabel"));
        this.$.passwordValue.set("content", "************");

        if (get(config, "profile.showIsAdult", false)) {
            this.$.isAdultLabel.set("content", i18nService.getString("app.ProfilePage.ProfileSection.isAdultLabel"));

            if (get(authService, "user.is_adult", false) === true) {
                this.$.isAdultValue.set("content", i18nService.getString("app.ProfilePage.ProfileSection.isAdult.adultValue"));
            }
            else if (get(authService, "user.is_adult", false) === false) {
                this.$.isAdultValue.set("content", i18nService.getString("app.ProfilePage.ProfileSection.isAdult.kidValue"));
            }
            else {
                this.$.isAdultValue.set("content", i18nService.getString("app.ProfilePage.ProfileSection.isAdult.unknownValue"));
            }

            this.$.isAdultLabel.show();
            this.$.isAdultValue.show();
            this.$.changeIsAdultButton.show();
        }
        else {
            this.$.isAdultLabel.hide();
            this.$.isAdultValue.hide();
            this.$.changeIsAdultButton.hide();
            this.$.isAdultLabel.set("content", "");
            this.$.isAdultValue.set("content", "");
            this.$.changeIsAdultButton.set("content", "");
        }
    }

});
